import { useSelector } from 'react-redux';
import { selectIsBankIdActive, selectPhoneNumber } from 'views/CheckoutPage/selector';
import { rm } from 'utils';
import { selectIsQuickStart } from './selector';
import { useEffect, useState } from 'react';

interface OwnProps {
  className: string;
}
export const DisclaimerInfo = ({ className }: OwnProps) => {
  const phoneNumber = useSelector(selectPhoneNumber);
  const isBankIdActive = useSelector(selectIsBankIdActive);
  const isQuickStart = useSelector(selectIsQuickStart);
  const [showSecurityDisclaimer, setShowSecurityDisclaimer] = useState(false);

  useEffect(() => {
    if (isBankIdActive && isQuickStart) {
      setShowSecurityDisclaimer(false);
    } else if (isBankIdActive && !isQuickStart) {
      setShowSecurityDisclaimer(true);
    } else {
      setShowSecurityDisclaimer(true);
    }
  }, [isBankIdActive, isQuickStart]);

  return (
    <div className={className}>
      {showSecurityDisclaimer && <p>{rm('checkout_contact_info_delivery_payment_info')}</p>}
      <p>{rm('checkout_contact_info_delivery_postbox_info', phoneNumber)}</p>
    </div>
  );
};
